var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.color === 'Step')?_c('StepBackground',[_vm._t("default")],2):(_vm.color === 'Checkpoint')?_c('CheckpointBackground',[_vm._t("default")],2):(_vm.color === 'Milestone')?_c('MilestoneBackground',[_vm._t("default")],2):(_vm.color === 'Challenge')?_c('ChallengeBackground',[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }